import { PersonalityDiagnosisResult } from './scoring';

const STORAGE_KEY = 'memorii_personality_result_v1';

export function saveDiagnosisResult(result: PersonalityDiagnosisResult): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(result));
  } catch {
    // localStorageが使えない環境（プライベートブラウズ等）では保存をあきらめる
  }
}

export function loadDiagnosisResult(): PersonalityDiagnosisResult | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PersonalityDiagnosisResult;
  } catch {
    return null;
  }
}
